<template>
    <div>
        <Button :disabled="true" text='Select Size' theme='dark' :wide_letter_spacing='true'/>
    </div>
</template>
<script>
import Button from '@/ecom/components/buttons/Button.vue';
export default {
    components: {Button}
}
</script>